function mobileNav() {
  return {
    mobileNavOpen: false,
  };
}

window.mobileNav = mobileNav;
